/* tslint:disable */
// WARNING: Computer generated file.  Do not hand modify.


export interface CommandExecutor {
  invokeCommand<T>(namespace: string, commandName: string, params: object): Promise<T>;
}




export interface CopyTextToClipboardParameters {

        /**
         * TextToCopy: 
         *     general text parameter
         */
        valueString: string,
}

export interface CopyTextToClipboardResponse {
}

/**
 * CopyTextToClipboard
 * Command Wrapper for CopyTextToClipboard
 * Copy text to clipboard, used in desktop hybrid dialogs
 */
export function CopyTextToClipboard(
    params: CopyTextToClipboardParameters,
    executor: CommandExecutor
): Promise<CopyTextToClipboardResponse> {

    return executor.invokeCommand<CopyTextToClipboardResponse>('tabui', 'copy-text-to-clipboard', params);
}

// For interopability with SimpleCommandsPresModels and the command-support module.
export interface CopyTextToClipboardCommandPresModel {
    commandNamespace: 'tabui',
    commandName: 'copy-text-to-clipboard',
    commandParams: Partial<CopyTextToClipboardParameters>
}
